/** @format */

export function getGtmRoomType(flatType?: string) {
  if (flatType === 'SharedApartment') {
    return 'private_room';
  } else if (flatType === 'StudioApartment') {
    return 'studio';
  } else if (flatType === 'OneBedroomApartment') {
    return 'one_bedroom';
  } else {
    return 'private_room';
  }
}
